<template>
  <footer class="custom-footer">
    <BContainer fluid class="py-5">
      <BRow>
        <BCol cols="12">
          <div>
            <div class="text-center mb-4">
              <h2>Dal 1997 siamo membri di SVIT Associazione Svizzera dei fiduciari immobiliari</h2>
              
            </div>
            <div class="images">
              <img src="@/assets/images/footer/svit.png" alt="SVIT">
              <img src="@/assets/images/footer/SEFRI.png" alt="SEFRI">
              <img src="@/assets/images/footer/CATEF.jpg" alt="CATEF">
              <img src="@/assets/images/footer/logo-acf-square.png" alt="ACF">
            </div>
          </div>
        </BCol>
      </BRow>
      <hr class="my-5">
      <BRow>
        <BCol cols="12" md="3" class="text-center mb-4 mb-md-0">
          <h2>CONTATTI</h2>
          <div class="footer-links">
            <div><i class="ri-phone-fill"></i><a href="tel:+41 91 825 20 40">+41(0)91 825 20 40</a></div>
            <div><i class="ri-printer-fill"></i>+41 (0)91 825 20 42</div>
            <div><i class="ri-mail-fill"></i><a href="mailto:info@immoprogramm.ch">info@immoprogramm.ch</a></div>
          </div>
        </BCol>
        <BCol cols="12" md="3" class="text-center mb-4 mb-md-0">
          <h2>ORARI DI APERTURA</h2>
          <div class="footer-links">
            <div>Lunedì - Giovedì <br> 8:00 - 12:00 / 13:30 - 17:00</div>
            <div>Venerdì <br>7:00 - 13:00</div>
          </div>
        </BCol>
        <BCol cols="12" md="3" class="text-center mb-4 mb-md-0">
          <h2>BELLINZONA</h2>
          <div class="footer-links">
            <div><i class="ri-map-pin-fill"></i>Viale Stazione 4,<br> 6500 Bellinzona</div>
            <div><i class="ri-phone-fill"></i><a href="tel:+41 (0)91 825 20 40">+41 (0)91 825 20 40</a></div>
            <div><i class="ri-printer-fill"></i>+41 (0)91 825 20 42</div>
            <div><i class="ri-mail-fill"></i><a href="mailto:info@immoprogramm.ch">info@immoprogramm.ch</a></div>
          </div>
        </BCol>
        <BCol cols="12" md="3" class="text-center mb-4 mb-md-0">
          <h2>LUGANO</h2>
          <div class="footer-links">
            <div><b>SOLO SU APPUNTAMENTO</b></div>
            <div><i class="ri-map-pin-fill"></i>Via Tesserete 67,<br> 6942 Savosa</div>
            <div><i class="ri-phone-fill"></i><a href="tel:+41 (0)91 993 30 70">+41 (0)91 993 30 70</a></div>
            <div><i class="ri-printer-fill"></i>+41 (0)91 825 20 42</div>
            <div><i class="ri-mail-fill"></i><a href="mailto:info@immoprogramm.ch">info@immoprogramm.ch</a></div>
          </div>
        </BCol>
      </BRow>
    </BContainer>
    <BContainer fluid class="p-3" style="background-color: #1c1c1c;">
      <BRow no-gutters class="w-100">
          <BCol class="d-flex justify-content-center">                                 
              <p class="mb-0 text-right">
                {{ $t("t-copyright") }}
                <router-link :to="{ name: 'privacy-policy' }" class="text-info">Privacy & Policy</router-link>
                - Powered by
                  <a href="https://domusfolio.ch/" target="_blank" class="text-info ml-2">  DomusFolio.ch</a>
              </p>
          </BCol>
      </BRow>
  </BContainer>
  </footer>
</template>

<style>
.custom-footer {
  background-color: #333; /* Dark background */
  color: #f8f9fa; /* Light color for all text */
}

.custom-footer h2 {
  color: inherit; /* Ensures h2 headers inherit the footer text color */
  display: inline-block;
  position: relative;
  margin-bottom: 20px;
  max-width: 1200px;
}

.custom-footer h2::after {
  content: '';
  display: block;
  width: 105px;
  height: 3px;
  background-color: #17a2b8; /* Bootstrap "info" color */
  position: absolute;
  left: 0;
  bottom: -5px; /* Adjust as needed */
}

.footer-links div {
  padding: 3px 0; /* Add padding for spacing between items if needed */
}

.footer-links i {
  margin-right: 5px; /* Space between the icon and the text */
}

.footer-links a {
  color: inherit; /* Inherit color from parent */
}

.images {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap; /* Allow wrapping on small screens */
}

.images img {
  height: 70px; /* Uniform height for all images */
  margin: 10px; /* Space between images */
}

@media (max-width: 767px) {
  .footer-links div {
    text-align: center; /* Center text on mobile screens */
  }
}
</style>